import React from 'react';
import PropTypes from 'prop-types';
import Preview from '@src/components/Preview';
import { COMPANY_ROUTE } from '@src/components/Preview/appRoutes';
import './styles.scss';

export default function LoadError({ error }) {
  return (
    <div className="page company-form company-form-error">
      <Preview url={COMPANY_ROUTE} />

      <div className="page-content-wrapper">
        <h2 className="company-form-title">Company profile</h2>

        <div className="page-content">{error}</div>
      </div>
    </div>
  );
}

LoadError.propTypes = {
  error: PropTypes.string.isRequired,
};
